<template>
    <div>
        <div style="height:250px;">
            <div v-if="!signerInfo" class="text-center text-muted">
                {{translate('processingMessages.gettingSignerInfo')}}
            </div>
            <div v-else>
                <table class="table table-sm table-borderless ozet">
                    <tbody>
                        <tr v-show="signerInfo.User">
                            <td style="width:150px;">{{translate('mobileSign.signer')}}</td>
                            <td style="width:1px;">:</td>
                            <td>{{ signerInfo.User.FullName }}</td>
                        </tr>
                        <tr>
                            <td>{{translate('mobileSign.operator')}}</td>
                            <td style="width:1px;">:</td>
                            <td>{{ signerInfo.Operator }}</td>
                        </tr>
                        <tr>
                            <td>{{translate('mobileSign.number')}}</td>
                            <td style="width:1px;">:</td>
                            <td>{{ signerInfo.Number }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="alert alert-danger" v-show="signerInfo.Error">
                    {{ signerInfo.Error }}
                </div>
                <div v-if="item" class="text-center">
                    <div style="font-weight:bold">
                        {{ item.FileName }}
                    </div>
                    <div v-if="item.Fingerprint">
                        <p>
                            <code>{{ item.Fingerprint }}</code>
                        </p>
                    </div>
                    <div v-if="item.error" class="text-danger">{{ item.error }}</div>
                </div>
                <div v-show="timerShow"
                    style="margin-top:10px; display:flex; justify-content: center; align-items: center;">
                    <div id="countDown" class="counter-container">
                        <circular-count-down-timer-vue ref="countdown" :circles="circles"
                        :main-circle-id="'1'" :stop-conditions="{ '1': 0 }" />
                    </div>
                </div>
            </div>
        </div>

        <div class="item-list" v-if="showFileList">
            <table class="table table-borderless table-hover">
                <tbody>
                    <tr v-for="i in items" :key="i.Id">
                        <td>
                            {{ i.FileName }} <small class="text-muted">{{ i.Size | prettyBytes }}</small>
                            <div v-if="!i.OK && i.ModelState" class="text-muted" style="font-size:0.7rem;">
                                <div v-for="errList in i.ModelState" :key="errList">
                                    <div v-for="e in errList" :key="e">{{ e }}</div>
                                </div>
                            </div>
                        </td>
                        <td style="width:250px;">
                            <div v-if="i.State == signStatus.prepearing">
                                <spinner :sr="translate('processingMessages.calculatingFingerprint')" />
                                {{translate('processingMessages.calculatingFingerprint')}}
                            </div>
                            <div v-else-if="i.State == signStatus.signing">
                                <spinner :sr="translate('processingMessages.signatureWaiting')" />
                                {{translate('processingMessages.signatureWaiting')}}
                            </div>
                            <div v-else-if="i.State == signStatus.sending">
                                <spinner :sr="translate('sending')" />
                                {{translate('sending')}}
                            </div>
                            <div v-else-if="i.State == signStatus.completed">
                                <icon-check class="text-success" />
                                {{translate('dashboard.completed')}}
                            </div>
                            <div v-else-if="i.State == signStatus.canceled">
                                <icon-exclamation-triangle class="text-warning" />
                                {{translate('finalizerStates.cancelled')}}
                            </div>
                            <div v-else-if="i.State == signStatus.error">
                                <icon-exclamation-octagon class="text-danger" />
                                {{translate('imzalayici.error')}}
                            </div>
                            <div v-else>{{ i.State }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-danger" v-show="this.error">{{ this.error }}</div>
        <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
            <spinner />
            {{ processingMessage }}
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import iconCheck from '@/components/Icons/check.svg'
import iconExclamationOctagon from '@/components/Icons/exclamation-octagon.svg'
import iconExclamationTriangle from '@/components/Icons/exclamation-triangle.svg'
import CircularCountDownTimerVue from './CircularCountDownTimer.vue'

const signStatus = {
    prepearing: 'prepearing',
    signing: 'signing',
    sending: 'sending',
    completed: 'completed',
    canceled: 'canceled',
    error: 'error'
};

export default {
    components: {
        spinner,
        iconCheck,
        iconExclamationOctagon,
        iconExclamationTriangle,
        CircularCountDownTimerVue
    },
    props: {
        items: Array,
        processingMessage: null, // İşlem yapılıyor, lütfen bekleyin mesajı. Dosyaların imzalanması tamamlandıktan sonra sunucuya gönderilirken gösterilmek üzere...
        showFileList: {
            default: true,
            type: Boolean
        },
    },
    data() {
        return {
            error: "",
            signStatus: signStatus,
            signerInfo: null,          // İmzacı bilgileri
            item: null,                // Şu anda imzalanmakta olan dosya
            loading: false,
            timerShow: false,
            circles: [
                {
                    strokeColor: "#17a2b8",
                    strokeWidth: 3,
                    id: '1',
                    steps: 60,
                    size: 50,
                    value: 60,
                    stepLength: -1,
                }
            ],
        };
    },
    created() {
        axios.get('/mobilesign/signerinfo')
            .then(x => {
                this.signerInfo = x.data.Data;
                console.log('signerInfo:', this.signerInfo);
            })
            .catch(x => {
                this.signerInfo = {
                    Error: this.translate('errors.mobileSignInfoFailed')
                };
                console.log('Mobil imza bilgileri alınamadı: ', x);
            });
    },
    methods: {
        restartCountDown(val){
            try {
                this.$refs.countdown.restartTimer(val);
            }catch(e){
                console.log(e);
            }
            
        },
        setLoading(isLoading) {
            this.loading = isLoading;
            if(!isLoading) {
                this.restartCountDown(1);
                
            }
                
            this.$emit('onloading', isLoading);
        },
        cancel() {
            this.canceled = true;
            this.setLoading(false);
        },
        signDocument(index) {
            this.item = this.items[index];
            this.item.State = signStatus.prepearing;
            this.item.error = '';
            this.restartCountDown(this.circles[0].value);
            axios.get(this.item.FingerprintUrl).then(x => {
                console.log('Fingerprint result: ', x.data)
                if (x.data.Success) {
                    this.item.Fingerprint = x.data.Data.Fingerprint;
                    
                    this.item.State = signStatus.signing;
                    this.$forceUpdate();

                    var dataUrl = this.item.PostUrl.replace("{0}", x.data?.Data?.FingerPrintTempFileId)
                
                    console.log(dataUrl);

                    setTimeout(() => {
                        axios.get(dataUrl).then(x => {
                            console.log('mobile sign result:', x.data);
                            if (x.data.Success) {
                                this.item.State = signStatus.completed;
                                this.item.OK = true;

                                
                                if (index + 1 < this.items.length) {
                                    this.signDocument(index + 1);
                                } else {
                                    this.$emit('completed', this.items);
                                    this.setLoading(false);
                                }
                            }
                        })
                            .catch(x => {
                                console.log('Mobil imza başarısız: ', x);
                                // this.item.error = this.translate('errors.cantCompleteSigning');
                                this.item.error = x.response.data.ModelState.UserException[0];
                                this.item.State = signStatus.error;
                                this.item.OK = false;
                                this.setLoading(false);
                                this.timerShow = false;
                            })
                            .then(() => {
                                this.$forceUpdate();
                            });
                    }, 1500)


                } else {
                    this.item.error = x.response.data.ModelState.UserException[0];
                }
            })
                .catch(x => {
                    // this.item.error = this.translate('errors.cantCalculateFingerprint');
                    this.item.error = x.response.data.ModelState.UserException[0];
                    this.item.State = signStatus.error;
                    this.restartCountDown(1);
                    this.timerShow = false;
                    console.log('Parmak izi alınamadı: ', x);
                })
                .then(() => {
                    this.$forceUpdate();
                })
        },
        sign() {
            this.timerShow = true;
            this.setLoading(true);
            this.signDocument(0);
        }
    }
}
</script>

<style scoped>
.item-list {
    background: #FFF;
    border: 1px solid #E0E0E0;
    height: 200px;
    overflow-y: scroll;
}
</style>